<template>
  <div id="material-template-page">
    <div class="header">
      <span v-text="identities[identityId]"></span>
    </div>
    <materials-of-indentity
      :active-identity="currentIdentity"
      :have-id-photo="haveIdPhoto"
      :show-sample-and-template="true"
      v-if="currentIdentity"
    />
  </div>
</template>

<script>
import ProductService from '../services/productService';
import materialsOfIndentity from '../components/materialsOfIndentity';

export default {
  name: 'identityMaterials',
  data() {
    return {
      currentIdentity: null,
      identityId: 0,
      haveIdPhoto: 0,
      identities: [
        '在职人员',
        '自由职业者',
        '退休人员',
        '在校学生',
        '学龄前儿童',
      ],
      productService: new ProductService(this.$http),
    };
  },
  mounted() {
    const identityId = this.productService.getIdentityId();
    this.getIdentityMaterials(this.productService.getProductId(), identityId);
    this.identityId = identityId;
  },
  components: {
    materialsOfIndentity,
  },
  methods: {
    getIdentityMaterials(visaProductId, identityId) {
      if (!visaProductId) return;
      this.productService.getProduct(visaProductId).then((response) => {
        const product = response.body.body;

        this.haveIdPhoto = product.visa_photo_id;

        // 设置浏览器title
        document.title = `【熊猫签证】${product.product_name}${this.identities[identityId]}所需资料`;

        if (product.material && product.material.length > 0) {
          const currentIdentityMaterial = product.material.find(
            (identity) => identity.identity_id === identityId,
          );

          const parsedIndentitiesDatas =
            this.productService.parseIdentitiesData([currentIdentityMaterial]);

          this.currentIdentity = parsedIndentitiesDatas[0];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#material-template-page {
  background-color: #fff;
  padding: 0 0.2rem;
  .header {
    margin-bottom: 0.12rem;
    height: 0.5rem;
    width: 100%;
    text-align: center;
    font-size: 0.2rem;
    left: 0;
    top: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }
}
</style>
